// Bind an observable to the hover state of an element. The observable
// will be set to true when the element is hovered over and false when
// it's not.
//
// Examples
//
//    data-bind="hover: isFocused"
//
module.exports = {
  init: function(element, valueAccessor, allBindingsAccessor, viewModel) {
    var observable = valueAccessor();
    $(element).hover(
      function() { observable(true); },
      function() { observable(false); }
    );
  }
};

